// extracted by mini-css-extract-plugin
module.exports = {"wrap":"ErrorView_wrap__30sjT","name":"ErrorView_name__2AfoQ","wrapMast":"ErrorView_wrapMast__2_LZu","toTopBtn":"ErrorView_toTopBtn__240jz"};